module.exports = __webpack_public_path__ + "img/img-3.4e0807a4.jpg";